import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HelpCircleIcon, ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'Es que no sé si me va a quedar bien',
    a: 'Por eso te invitamos a venir y probarlo. No compras nada que no te haga sentir increíble.'
  }, {
    q: '¿Y si no encuentro mi talla?',
    a: 'Trabajamos con diferentes tallas y cortes. Cuéntanos tu contextura y te orientamos antes de venir.'
  }, {
    q: '¿Los precios son accesibles?',
    a: 'Tenemos opciones para diferentes presupuestos. Lo que nunca negociamos es la calidad.'
  }, {
    q: '¿Puedo ver el catálogo primero?',
    a: 'Claro — escríbenos al WhatsApp y te enviamos lo disponible ahora mismo.'
  }, {
    q: 'No tengo tiempo de ir a la tienda',
    a: 'Abrimos desde las 8am. Puedes venir antes de tu día de trabajo. También atendemos por WhatsApp.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 bg-cream-50" data-id="element-83">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <div className="text-center mb-12" data-id="element-85">
          <HelpCircleIcon className="h-8 w-8 text-olive-500 mx-auto mb-4" strokeWidth={1.5} data-id="element-86" />
          <h2 className="text-3xl font-display text-charcoal" data-id="element-87">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-88">
          {faqs.map((faq, idx) => <div key={idx} className="border border-cream-200 bg-white overflow-hidden" data-id="element-89">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-90">
                <span className="font-medium text-charcoal pr-8" data-id="element-91">{faq.q}</span>
                <ChevronDownIcon className={`h-5 w-5 text-olive-500 flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-92" />
              </button>

              <AnimatePresence data-id="element-93">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-94">
                    <div className="px-6 pb-4 pt-2 text-charcoal/70 font-light border-t border-cream-100" data-id="element-95">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}